import { bindServices } from '@/services/api';

const api = bindServices('token');
import { queryEditActive } from './service';

import { toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import _ from 'lodash';

const { ManageTokenTrace } = CoreQueries;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'token',

  state: {
    newToken: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: { ...meta },
    select: 'id,isActive,reportType,token',
    notSelectSearch: 'id,isActive,reportType,process,processInstance,userCreator,dynamicEntity',
    expand: {
      process: { select: 'name' },
      processInstance: { select: 'name' },
      dynamicEntity: { select: 'displayName' },
    },
    paramsView: {
      select: 'id,isActive,reportType,token,created,updated',
      expand: {
        process: { select: 'name' },
        processInstance: { select: 'name' },
        userCreator: { select: 'fullName' },
        dynamicEntity: { select: 'displayName' },
      },
    },
    paramsEdit: {
      select: 'id,isActive,reportType',
    },
    view: false,
    orderBy: '',
    id: null,
    openTokenTraceDrawer: false,
    tokenTraceList: [],
    paginationTokenTrace: { ...meta },
    searchTableTokenTrace: '',
    orderByReportToken: '',
    openTokenTraceDetail: false,
    selectedItemTrace: null,
    idTrace: null,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'reportToken/paged',
          params: payload,
        });
        yield put({
          type: 'queryTokens',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewToken({ payload }, { put }) {
      yield put({
        type: 'addToken',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewToken',
          payload,
        });
      }
    },

    *editItemToken({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'reportToken',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editToken',
          payload: {
            ...payload,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveNewToken({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'reportToken',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveToken',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveEditToken({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'reportToken',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveToken',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `reportToken/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'deleteToken',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },

    *showItemToken({ view }, { put }) {
      yield put({
        type: 'showEditItemToken',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *toggleTokenTraceDrawer({ payload }, { put }) {
      yield put({
        type: 'queryToggleTokenTraceDrawer',
        payload,
      });
    },
    *fetchTokenTraceList({ payload }, { call, put }) {
      try {
        const params = {
          route: `reportToken/traces/${payload.idReportToken}`,
          ...{
            page: payload.page,
            limit: payload.limit,
            search: payload.search,
            orderBy: payload.orderBy,
          },
          ...ManageTokenTrace.paged,
        };
        const response = yield call(api.getAll, params);
        yield put({
          type: 'queryTokenTraceList',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
            searchTable: payload.search,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *setOrderTokenTrace({ payload }, { put }) {
      yield put({
        type: 'querySetOrderTokenTrace',
        payload,
      });
    },
    *toggleTokenTraceDetail({ payload }, { put }) {
      yield put({
        type: 'queryToggleTokenTraceDetail',
        payload,
      });
    },
    *fetchItemTrace({ payload }, { call, put }) {
      try {
        const params = {
          route: `reportToken/traces/${payload.idReportToken}`,
          ...ManageTokenTrace.detail,
          ...{
            filter: `id eq ${payload.idTrace}`,
          },
        };
        const response = yield call(api.getAll, params);
        yield put({
          type: 'queryFetchItemTrace',
          payload: {
            ...response,
          },
        });
      } catch (error) {
        /*  */
      }
    },
  },

  reducers: {
    queryTokens(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addToken(state, { payload }) {
      return {
        ...state,
        newToken: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewToken(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editToken(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    showDetails(state, { payload }) {
      return {
        ...state,
        showDetails: payload,
      };
    },

    saveToken(state, { payload }) {
      return {
        ...state,
        saveToken: payload,
        newToken: false,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },

    showEditItemToken(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newToken: false,
        selectedItem: null,
        view: false,
        id: '',
        orderBy: '',
      };
    },

    queryToggleTokenTraceDrawer(state, { payload }) {
      return {
        ...state,
        openTokenTraceDrawer: payload.state,
        id: payload.id,
      };
    },

    queryTokenTraceList(state, { payload }) {
      return {
        ...state,
        tokenTraceList: payload.items,
        paginationTokenTrace: _.merge(state.paginationTokenTrace, toPaginate(payload)),
        searchTableTokenTrace: payload.searchTable,
      };
    },

    querySetOrderTokenTrace(state, { payload }) {
      return {
        ...state,
        orderByReportToken: payload.value,
      };
    },
    queryToggleTokenTraceDetail(state, { payload }) {
      return {
        ...state,
        openTokenTraceDetail: payload.state,
        idTrace: payload.state ? payload.idTrace : null,
        selectedItemTrace: [],
      };
    },
    queryFetchItemTrace(state, { payload }) {
      return {
        ...state,
        selectedItemTrace: payload.items[0],
      };
    },
  },
};

export default Model;
